module.exports = __webpack_public_path__ + "img/clogo.a25468a9.png";